/**
 * @file Entrypoint for whiteboard page.
 */

import { setupSurfaceVueApp } from '@@/bits/surface_page'
import Whiteboard from '@@/vuecomponents/Whiteboard.vue'

setupSurfaceVueApp(Whiteboard)
